<template>
  <div>
    <v-btn color="warning" @click="open()" icon>
      <v-icon>mdi-pencil</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Edit Employee"
          icon="mdi-account-edit"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <div>
            <v-form ref="form">
              <!-- {{ item.is_active }} -->
              <v-radio-group v-model="item.is_active" row label="Active Status">
                <v-radio label="Inactive" :value="0"></v-radio>
                <v-radio label="Active" :value="1"></v-radio>
              </v-radio-group>
              <v-text-field
                outlined
                dense
                label="Employee Name"
                v-model="item.name"
                prepend-icon="mdi-account-circle"
                :rules="rules"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                label="Contact Number"
                v-model="item.contact_no"
                prepend-icon="mdi-phone"
                :rules="rules"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                label="Address"
                v-model="item.address"
                prepend-icon="mdi-map-marker"
                :rules="rules"
              ></v-text-field>
              <div class="d-flex">
                <p>Birth Date</p>
                <input type="date" v-model="item.birth_date" class="" />
              </div>
              <v-select
                outlined
                dense
                label="Position"
                :items="positions"
                prepend-icon="mdi-tools"
                :rules="rules"
                v-model="item.position_id"
                item-text="name"
                item-value="id"
              ></v-select>
              <v-select
                outlined
                dense
                label="Branch"
                :items="branches"
                prepend-icon="mdi-source-branch"
                :rules="rules"
                v-model="item.branch_id"
                item-text="branch_name"
                item-value="id"
              ></v-select>
              <v-text-field
                outlined
                dense
                label="Overtime Rate"
                v-model="item.overtime_rate"
                prepend-icon="mdi-hand-coin"
                :rules="rules"
              ></v-text-field>

              <div class="d-flex">
                <p>Employment Date</p>
                <input type="date" v-model="item.date_of_employment" class="" />
              </div>
              <v-select
                outlined
                dense
                label="Employment Status"
                :items="employmentStatuses"
                item-text="text"
                item-value="value"
                prepend-icon="mdi-account-check"
                :rules="rules"
                v-model="item.employment_status"
              ></v-select>
              <p v-if="monthsEmployed >= 3" class="caption orange--text mt-n4">
                {{ monthsEmployed }} months employed — past the 3-month
                probation, due for regularization.
              </p>
              <v-text-field
                outlined
                dense
                v-if="item.employment_status === 'regular'"
                label="Monthly Salary"
                v-model="item.monthly_salary"
                prepend-icon="mdi-cash-multiple"
                type="number"
                :rules="rules"
              ></v-text-field>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" :loading="loading">Edit</v-btn>
          <v-btn @click="dialog = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      form: {},
      rules: [(value) => !!value || "Field is Required."],
      loading: false,
      employmentStatuses: [
        { text: "Probationary", value: "probationary" },
        { text: "Regular", value: "regular" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      positions: "position/positions",
      branches: "branch/branches",
    }),
    monthsEmployed() {
      if (!this.item.date_of_employment) return 0;
      return moment().diff(moment(this.item.date_of_employment), "months");
    },
  },
  methods: {
    ...mapActions({
      edit_employee: "employee/edit_employee",
      get_branches: "branch/get_branches",
    }),
    open() {
      // Make sure the branch list is available for the selector.
      if (this.branches.length == 0) this.get_branches();
      this.dialog = true;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        let x = await this.$confirm({
          title: "Edit Employee",
          message: "Are you sure you want to edit this new employee?",
          color: "primary",
          icon: "mdi-pencil",
        });
        if (x) {
          this.loading = true;
          this.edit_employee(this.item)
            .then(() => {
              this.$alert({
                title: "Success",
                message: "Successfully edited a new employee",
                color: "success",
                icon: "mdi-check-circle",
              });
              this.loading = false;
            })
            .catch((err) =>
              this.$alert({
                title: "Error",
                message: String(err),
                color: "error",
                icon: "mdi-alert-circle",
              })
            );
        }
      } else {
        this.$alert({
          title: "Validation",
          message: "Please check some fields",
          color: "warning",
          icon: "mdi-alert",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
